import { type FC } from 'react'
import { Stack, Snackbar as MuiSnackbar, Slide } from '@mui/material'
import { motion, AnimatePresence } from 'motion/react'

import { SnackbarToast } from './SnackbarToast.js'
import { ToastProps } from './SnackbarProvider.js'

type Props = {
  toasts: ToastProps[]
}

export const Snackbar: FC<Props> = ({ toasts }) => {
  const newToasts = [...toasts]

  if (!toasts || toasts.length === 0) {
    return null
  }

  if (toasts[0].position?.vertical === 'top') {
    newToasts.reverse()
  }

  const variants = {
    initial: {
      opacity: 0,
    },
    animate: {
      opacity: 1,
      transition: {
        opacity: { duration: 0.2 },
      },
    },
    exit: {
      opacity: 0,
      transition: {
        opacity: { duration: 0.2 },
      },
    },
  }

  return (
    <MuiSnackbar
      id="snackbar-container"
      open
      autoHideDuration={null}
      transitionDuration={0}
      TransitionComponent={Slide}
      anchorOrigin={toasts[0].position}
      sx={{
        mt: 'env(safe-area-inset-top)',
        mb: 'env(safe-area-inset-bottom)',
      }}
    >
      <Stack
        flexDirection="column"
        gap={1}
        sx={{
          width: { xs: '100vw', sm: toasts[0].width },
          px: 2.5,
          py: { xs: 1, sm: 0 },
        }}
      >
        <AnimatePresence initial={false}>
          {newToasts.map((toast) => (
            <motion.div
              key={toast.key}
              layout
              variants={variants}
              initial="initial"
              animate="animate"
              exit="exit"
              style={{ backgroundColor: 'transparent' }}
            >
              <SnackbarToast toast={toast} />
            </motion.div>
          ))}
        </AnimatePresence>
      </Stack>
    </MuiSnackbar>
  )
}
